export default __webpack_public_path__ + "b1c4f33da01a4126d10633255a2cc106.svg";